export default __webpack_public_path__ + "assets/models/421529210cc814fbcd601fcc2875139a.glb";